module.exports = __webpack_public_path__ + "img/google-play.743e8f38.png";